const FEATURE_CHAT_BOT = 'chat-bot';
const FEATURE_DATA_SOURCE = 'data-source';
const FEATURE_MAILMERGE_CHANNEL_QUEUE = 'mail-merge-channel-queue';
const FEATURE_NEW_TWILIO = 'new-twilio';
const FEATURE_MASS_ACTION_RESOLVE = 'mass-action-resolve';
const FEATURE_INCLUDE_FORM_RESPONSE = 'include-form-response';
const FEATURE_USE_BOT_FOR_SUGGESTIONS = 'bot-suggestions';
const FEATURE_GECKO_INTEGRATIONS = 'gecko-integrations';
const FEATURE_AI_ACTIONS = 'ai-actions';
const FEATURE_ONLY_RECENT_CONVERSATIONS = 'recent-conversations';
const FEATURE_AI_ENGINE = 'ai-engine';
const FEATURE_GPT4 = 'gpt4';
const FEATURE_TEAM_CHANNELS = 'team-channels';
const FEATURE_ENGAGE_CONTACT_EVENTS = 'engage-contact-events';
const FEATURE_SYNC_SDK_FORM_RESPOND = 'submit-form-sync-sdk';
const FEATURE_AI_INSIGHTS = 'ai-insights';

const FEATURES = [
  FEATURE_CHAT_BOT,
  FEATURE_DATA_SOURCE,
  FEATURE_MAILMERGE_CHANNEL_QUEUE,
  FEATURE_NEW_TWILIO,
  FEATURE_MASS_ACTION_RESOLVE,
  FEATURE_INCLUDE_FORM_RESPONSE,
  FEATURE_USE_BOT_FOR_SUGGESTIONS,
  FEATURE_GECKO_INTEGRATIONS,
  FEATURE_AI_ACTIONS,
  FEATURE_ONLY_RECENT_CONVERSATIONS,
  FEATURE_AI_ENGINE,
  FEATURE_GPT4,
  FEATURE_TEAM_CHANNELS,
  FEATURE_ENGAGE_CONTACT_EVENTS,
  FEATURE_SYNC_SDK_FORM_RESPOND,
  FEATURE_AI_INSIGHTS,
];

module.exports = {
  FEATURE_CHAT_BOT,
  FEATURE_DATA_SOURCE,
  FEATURE_MAILMERGE_CHANNEL_QUEUE,
  FEATURE_NEW_TWILIO,
  FEATURE_MASS_ACTION_RESOLVE,
  FEATURE_INCLUDE_FORM_RESPONSE,
  FEATURE_USE_BOT_FOR_SUGGESTIONS,
  FEATURE_GECKO_INTEGRATIONS,
  FEATURE_AI_ACTIONS,
  FEATURE_ONLY_RECENT_CONVERSATIONS,
  FEATURE_AI_ENGINE,
  FEATURE_GPT4,
  FEATURE_TEAM_CHANNELS,
  FEATURE_ENGAGE_CONTACT_EVENTS,
  FEATURE_SYNC_SDK_FORM_RESPOND,
  FEATURE_AI_INSIGHTS,
  FEATURES,
};
